import { render, staticRenderFns } from "./DadosGlosa.vue?vue&type=template&id=dc93b858&scoped=true&"
import script from "./DadosGlosa.vue?vue&type=script&lang=ts&"
export * from "./DadosGlosa.vue?vue&type=script&lang=ts&"
import style0 from "./DadosGlosa.vue?vue&type=style&index=0&id=dc93b858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc93b858",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSimpleTable,VTextField,VTooltip})
